import { CUSTOM_COLORS } from 'constants/colors';
import styled from 'styled-components';
import { Space, Button, Text, Modal } from '@cashfree-intl/coherent';

export const StyledContainer = styled(Space)`
  border-radius: 16px;
  background: linear-gradient(92deg, #d6dcff 10.31%, #ebe4f9 67.77%);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.06);
  margin-top: 1.5rem;
  padding: 3.5rem;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  align-items: center;
  gap: 1.5rem;
  max-width: 909px;
  width: 800px;
  justify-content: space-between;
`;

export const TopContainer = styled(Space)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* max-width: 800px; */
  padding: 1rem;
`;

export const Title = styled.div`
  margin-bottom: 1rem;
  font-size: 24px;
  font-family: ${props => props.theme.FONTS.semi_bold};
  color: ${CUSTOM_COLORS.MUTED_BLUE};
  line-height: normal;
`;

export const OptionCard = styled(Space)<{ selected: boolean }>`
  width: 338px;
  padding: 0px 28px 40px 28px;
  border-radius: 16px;
  background: white;
  text-align: center;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
  &:hover {
    box-shadow: 12px 12px 16px 0px rgba(0, 0, 0, 0.05);
  }
`;

export const Image = styled.img`
  width: 200px;
  height: 200px;
`;

export const ArrowImage = styled.img`
  width: 40px;
  height: 40px;
  margin-top: 12px;
`;

export const Icons = styled(Space)`
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
  justify-content: flex-start;
  align-items: center;
`;

export const Footer = styled.div`
  margin-top: 40px;
  font-size: 14px;
  color: gray;
  a {
    color: blue;
    text-decoration: underline;
  }
`;

export const StyledTitle = styled.div`
  text-align: center;
  margin-top: 3rem;
  margin-bottom: 1.5rem;
`;

export const StartPaymentsTitle = styled.div`
  font-size: 24px;
  font-family: ${props => props.theme.FONTS.semi_bold};
`;

export const StyledSpace = styled(Space)`
  display: flex;
  flex-direction: row;

  ${props =>
    props.wrap &&
    `
      flex-wrap: wrap;
    `}

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledButton = styled(Button)`
  width: 166px;
`;

export const ProductDescription = styled(Text)`
  font-family: ${props => props.theme.FONTS.semi_bold};
  font-size: 24px;
  line-height: 36px;
`;
export const ProductTitle = styled(Text)`
  font-size: 24px;
  line-height: 36px;
  font-family: ${props => props.theme.FONTS.normal};
`;

export const StyledModal = styled(Modal)`
  .ui.embed {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  @media only screen and (max-width: 767px) {
    .ui.embed {
      border-radius: 0.5rem;
    }
  }
`;

export const ModalOverlay = styled(Space)<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 10px;
  padding: 24px;
  width: 400px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const CardSpace = styled(Space)`
  background-color: white;
  border-radius: 1rem;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  max-width: 20rem;
`;

export const StyledTextTitle = styled(Text)`
  font-size: 24px;
  color: ${CUSTOM_COLORS.MUTED_BLUE};
  font-family: ${props => props.theme.FONTS.semi_bold};
`;
export const StyledSubTitle = styled(Text)`
  font-style: normal;
  font-family: ${props => props.theme.FONTS.medium};
  line-height: 125%;
  color: ${CUSTOM_COLORS.SECONDARY_6B6C7B};
  text-align: center;
`;

export const FooterContainer = styled(Space)`
  width: 100%;
  padding: 0 1.5rem 1.5rem;
  background-color: ${CUSTOM_COLORS.PRIMARY_F3EDF999};
`;

export const FooterContent = styled(Space)`
  margin-top: 40px;
  width: 100%;
  font-size: 14px;
  color: gray;
  text-align: center;
  justify-content: center;
`;

export const HeaderContainer = styled.header`
  width: 100%;
  height: 4rem;
  background-color: ${CUSTOM_COLORS.PRIMARY_F3EDF999};
  padding: 2rem;
`;

export const LogoWrapper = styled.div`
  svg {
    width: 6rem;
    height: auto;
  }
`;

export const NavigationWrapper = styled(Space)`
  padding: 20px 2rem;
  background-color: ${CUSTOM_COLORS.PRIMARY_F3EDF999};
`;

export const MainContainer = styled(Space)`
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  position: relative;
`;

export const Wrapper = styled(Space)`
  flex: 1;
  background-color: ${CUSTOM_COLORS.PRIMARY_F3EDF999};
  padding: 0rem 1rem 1rem;
  box-sizing: border-box;
  overflow-x: hidden;
`;

export const IllustrationImage = styled.img`
  width: 12rem;
  height: auto;
`;

export const FooterStyledText = styled(Text)`
  cursor: pointer;
  color: ${CUSTOM_COLORS.PRIMARY_6930ca};
  text-decoration: underline;
  margin: 0 4px;
`;

export const StyledIcons = styled.img`
  height: ${({ height }) => height || 'auto'};
  width: ${({ width }) => width || 'auto'};
`;

export const StyledIllustration = styled.img`
  width: 12rem;
  height: auto;
`;
